import { gql } from '@apollo/client';

export const FETCH_MEMBERS_COUNT = gql`
	query crewMembersCount($filter: CrewMemberSearchFilter!) {
		crewMembersCount(filter: $filter)
	}
`;

export const FETCH_CREW_MEMBERS = gql`
	query crewMembers($filter: CrewMemberSearchFilter!, $pagination: PaginationInput!) {
		crewMemberSearch(filter: $filter, pagination: $pagination) {
			results {
				id
				fullName
				currentHomeBase {
					city {
						name
					}
				}
				phone
				mobilityPartnerShortName
				driverCard
				validationErrors
			}
			page {
				page
				size
				totalPages
				totalCount
			}
		}
	}
`;
